import { RocketMark } from '@/components/brand/rocket-mark';
import { cn } from '@/lib/cn';

export function LaunchLoader({
  label,
  compact = false,
  className,
}: {
  label: string;
  compact?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn('launch-loader', compact && 'launch-loader--compact', className)}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span className="launch-loader__scene" aria-hidden="true">
        <span className="launch-loader__halo" />
        <span className="launch-loader__rocket">
          <RocketMark launching />
        </span>
        <span className="launch-loader__flame" />
        <span className="launch-loader__spark launch-loader__spark--one" />
        <span className="launch-loader__spark launch-loader__spark--two" />
        <span className="launch-loader__spark launch-loader__spark--three" />
      </span>
      <span className="launch-loader__label">{label}</span>
    </div>
  );
}
